var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.031,
    height: 12.031,
    viewBox: "0 0 12.031 12.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus-pink",
    transform: "translate(-1119.417 -223.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M1558.3,816.124a5.514,5.514,0,0,1,3.185.327,5.518,5.518,0,1,1-7.648,5.063,5.433,5.433,0,0,1,.11-1.076,5.513,5.513,0,0,1,4.352-4.315Z",
    transform: "translate(-433.92 -592.438)",
    fill: "none",
    stroke: "#c06c84",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    y2: 4.229,
    transform: "translate(1125.438 226.98)",
    fill: "none",
    stroke: "#c06c84",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 4.229,
    transform: "translate(1123.318 229.102)",
    fill: "none",
    stroke: "#c06c84",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPink);
export default __webpack_public_path__ + "static/media/plus-pink.75143f843b353f24173b294566ca9a59.svg";
export { ForwardRef as ReactComponent };